import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import { getHourlySales, getCsvReport } from 'actions/ReportsAction';
import { formInput } from 'actions/FormActions';
import { reportHourlySalesReport } from 'utils/breadcrumbInfo';
// Basic Components
import CardSimple from 'screens/components/basic/CardSimple';
import Grid from 'screens/components/basic/Grid';
import PageHeader from 'screens/components/basic/PageHeader';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
// Child Components
import Body from './Body';
import Header from './Header';

const HourlySales = () => {
    // Redux State
    const dispatch = useDispatch();
    const { branchId: loggedBranch, userBranches = [] } = useSelector(state => state.common || {});
    const { HourlySalesBranchOption: selectedBranch, HourlySalesSelectedDate } = useSelector(state => state.form || {});
    const selectedDate = moment(HourlySalesSelectedDate).format("YYYY-MM-DD");

    const branchOptions = userBranches.map(item => ({
        text: item.name,
        value: item.id.toString()
    }));

    // Local State
    const [activePage, setActivePage] = useState(1);
    const [itemsPerPage] = useState(20);
    const [showBody, setShowBody] = useState(false);

    useEffect(() => {
        const date = new Date();
        dispatch(formInput(date, `HourlySalesSelectedDate`));
    }, []);

    const getReport = () => {
        let branch = selectedBranch || loggedBranch;
        let productId = 0;
        let pageNumber = activePage;
        let pageSize = itemsPerPage;
        dispatch(getHourlySales({ branch, selectedDate }));
    };

    const downloadReport = () => {
        let branch = selectedBranch || loggedBranch;
        dispatch(getCsvReport(`reports/excel/hourlysales?branchid=${branch}&selectedDate=${selectedDate}`, "Hourlysales"));
    };

    const filter = () => {
        setActivePage(1);
        getReport();
    }

    const showBodyContent = () => {
        filter();
        setShowBody(true);
    };

    return (
        <Grid headerContent={reportHourlySalesReport}>
            <PageHeader 
                title={LOOKUP.report.hourlySales.text}
                description={LOOKUP.report.hourlySales.description}
                icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-hourly-sales-report" />}
            />
            <Header
                branchOptions={branchOptions}
                filter={filter}
                download={downloadReport}
                showBody={showBodyContent}
                loggedBranch={loggedBranch}
            />
            {showBody &&
                <CardSimple>
                    <Body />
                </CardSimple>
            }
        </Grid>
    )
}
export default HourlySales;